import { render, staticRenderFns } from "./LegalNotePage.vue?vue&type=template&id=05c04674&scoped=true&"
import script from "./LegalNotePage.vue?vue&type=script&lang=js&"
export * from "./LegalNotePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c04674",
  null
  
)

export default component.exports